import "../../css/app.css";
import * as React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';

export default function AttentionDialog(props) {
    const { name, onClose, open } = props;

    const handleCancel = () => {
        onClose();
    };

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { maxHeight: '700px' } }}
            open={open}
            style={{ overflow: "hidden" }}
            className="attention_dialog"
        >

            <h3 id="attention_dialog_header" style={{ paddingLeft: "10px" }}>{name}</h3>
            <span className="close_box" onClick={handleCancel}></span>

            <div style={{
                height: "100%",
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                padding: "20px 0",
                overflowY: "scroll"
            }}>
                <div className="mod-input">
                    <div style={{ paddingLeft: "40px", paddingRight: "40px" }}>
                        <p>
                            件名、及び、お問い合わせの内容について、以下の例のような特定のセキュリティ上のリスクを伴う文字・表現が含まれている場合は次ページの確認画面にてエラー※となる可能性がございます。お問い合わせが投稿できない場合には、該当する記述の変更・削除をお試しください。<br />
                            これらは、システム上のセキュリティを保護するための措置ですので、ご理解いただきますようお願い申し上げます。<br />
                            尚、添付ファイル内の文言につきましては、このチェックの対象外となります。このため、件名、及び、お問い合わせの内容に該当する記述が含まれる場合は、代替としてテキストファイル等にその内容を記載いただき、添付ファイルとしてアップロードしていただくことでも、お問い合わせを正常に投稿できます。<br />
                            <br />
                        </p>
                        <p>
                            (例)<br />
                            ・http、https、ftp、ftps、または、IPアドレス（127.0.0.1など）に関する表現<br />
                            &emsp;→対象の文字やIPアドレスを全角文字（ｈｔｔｐ：／／１２７．０．０．１ 等）に変更、<br />
                            &emsp;&emsp;または、削除をお試しください<br />
                            ・"file://xxx" や "../../" のようなファイル、ディレクトリ操作に関する表現<br />
                            &emsp;→対象の文字を全角文字（．．／．．／ 等）に変更、または、削除をお試しください<br />
                            ・"&lt;script&gt;～&lt;/script&gt;"のようなスクリプトの表現<br />
                            &emsp;→対象の文字を全角文字（＜ｓｃｒｉｐｔ＞ 等）に変更、または、削除をお試しください<br />
                            <br />
                        </p>
                        <p>※メッセージ：「現在サーバーが込み合っているか、または、システムメンテナンス中です。...」</p>
                    </div>
                </div>
            </div>
        </Dialog >
    );
}

AttentionDialog.propTypes = {
    name: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};